import { DatePicker } from 'antd';
import { styled } from 'styled-components';

const { RangePicker } = DatePicker;

export const Wrapper = styled.div`
    min-width: 100%;
    height: 100%;
    background-color: #f7f7f7;
    padding: 0 0 50px 0;
`;

export const Header = styled.div`
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    background: #ffffff;
    border-width: 0 0.5px 0.5px 0.5px;
    border-style: solid;
    border-color: #d6d6d6;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.11);
    border-radius: 0 0 5px 5px;
    padding: 22px 17px 21px 21px;
`;

export const WrapCalendar = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    max-width: fit-content;
    padding: 5px 15px;
    background: #eeefef;
    border-radius: 5px;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;
export const StyledRangePicker = styled(RangePicker)`
    width: 250px;
`;

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const WidgetWrap = styled.div<{ width: string }>`
    background-color: #ffffff;
    padding: 16px;
    display: flex;
    justify-content: center;
    border-radius: 5px;
    min-height: 400px;

    flex: ${props => (props.width === '66%' ? '2' : '1')};
    min-width: ${props => {
        if (props.width === '66%') return 'calc(66% - 5px)';
        if (props.width === '33%') return 'calc(33% - 5px)';
        if (props.width === '100%') return '100%';
        return 'calc(50% - 5px)';
    }};

    @media (min-width: 1024px) {
        height: 450px;
    }

    @media (max-width: 1024px) {
        min-width: calc(55% - 5px);
        height: 450px;
    }

    @media (max-width: 768px) {
        min-width: 100%;
        width: 100%;
        height: 450px;
    }
`;

export const Widget = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
